import Components from "./config/components";

export default [
  {
    name: "Home",
    path: "/",
    component: Components.Home,
    meta: {},
  },
  {
    name: "PersonalCredit",
    path: "/rata",
    component: Components.PersonalCredit,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalCreditUpgrade",
    path: "/rata-upgrade",
    component: Components.PersonalCreditUpgrade,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Contacts",
    path: "/contatti",
    component: Components.Contacts,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalData",
    path: "/anagrafica",
    component: Components.PersonalData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IncomeData",
    path: "/reddito",
    component: Components.IncomeData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmployerData",
    path: "/lavoro",
    component: Components.EmployerData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtection",
    path: "/assicurazione",
    component: Components.LoanProtection,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtectionConsent",
    path: "/assicurazione-consenso",
    component: Components.LoanProtectionConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtectionWarning",
    path: "/assicurazione-avviso",
    component: Components.LoanProtectionWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "DeliveryData",
    path: "/residenza",
    component: Components.DeliveryData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IdentityDocData",
    path: "/documento",
    component: Components.IdentityDocData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PaymentData",
    path: "/iban",
    component: Components.PaymentData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Partner",
    path: "/partner",
    component: Components.Partner,
    meta: {
      redirect: true,
    },
  },
  {
    name: "CustomCredit",
    path: "/filiali",
    component: Components.CustomCredit,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmailPrivacy",
    path: "/email-privacy",
    component: Components.EmailPrivacy,
    meta: {
      redirect: true,
    },
  },
  {
    path: "/typ",
    name: "Typ",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    path: "/ko",
    name: "TypKO",
    component: Components.TypKO,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  
];
